import { FC } from 'react';

import { useInsurancesCompaniesQuery } from '@/api/getters';
import ComboBox from '@/components/ui/ComboBox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';

import {
  ACCIDENT_REPORTED_TO_INSURER_NAME,
  ACCIDENT_REPORTED_TO_INSURER_NAME_COMPLEMENTARY,
  ACCIDENT_REPORTED_TO_INSURER_VALUES,
} from './RadioGroupAccidentReportedToInsurer';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const INSURANCE_COMPANY_NAME = 'insurance_company';
export const INSURANCE_COMPANY_NAME_COMPLEMENTARY =
  'insurance_company_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const SelectInsuranceCompany: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control, getValues } = useFormContext();
  const { data } = useInsurancesCompaniesQuery();

  const fieldName =
    name ??
    (isComplementary
      ? INSURANCE_COMPANY_NAME_COMPLEMENTARY
      : INSURANCE_COMPANY_NAME);

  const isMyInsure =
    getValues(
      isComplementary
        ? ACCIDENT_REPORTED_TO_INSURER_NAME_COMPLEMENTARY
        : ACCIDENT_REPORTED_TO_INSURER_NAME
    ) === ACCIDENT_REPORTED_TO_INSURER_VALUES.YES_MY_INSURE;

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: i18n.t('Uzupełnij to pole, aby przejść dalej'),
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>
            {isMyInsure
              ? i18n.t('Wskaż nazwę Twojego ubezpieczyciela')
              : i18n.t('Wskaż nazwę ubezpieczyciela sprawcy')}
          </FormLabel>
          <FormControl>
            <ComboBox
              field={field}
              placeholder={'Wybierz towarzystwo ubezpieczeń'}
              success={!fieldState.error && field.value}
              options={data ?? []}
              data-testid="select-insurance-company"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
